module.exports = __webpack_public_path__ + "d48dbec57b10e3074211e084de15b298.svg";